import { HttpErrorResponse } from '@angular/common/http';
import { FiltroJudicial } from './../../../models/FiltroJudicial';
import { CobranzasService } from './../../../services/cobranzas/cobranzas.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DatePipe } from '@angular/common';
import { MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus } from './../../../models/messages';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import * as moment from 'moment';
import Swal from "sweetalert2";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-listado-cobranza-judicial',
  templateUrl: './listado-cobranza-judicial.component.html',
  styleUrls: ['./listado-cobranza-judicial.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,DatePipe,MessagesStatus,
    {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
      },
  
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
]
})
export class ListadoCobranzaJudicialComponent implements OnInit {
  DTOFiltrosJudicial: FiltroJudicial = new FiltroJudicial();

  today = moment();
  loading:boolean;
  TipoMoneda: any = ""; 
  abrirCancelarJudicial : boolean = false;
  abrirDetalleJudicial : boolean = false;
  filteredAdquirentes: Observable<any[]>;
  adquirentessArr;
  rucAdqTemporal : any;
  rucAdq = new FormControl();
  idAdq ="";
  idAdqui:any;
  RUC_ADQ : string;
  arrayJudicial :any=[];
  dataEnviar :any={};
  user:any;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns = ['checked','idComprobante','idCobranza_Judicial','Nombre_Comercial','Fecha_Registro','Moneda','VNPP','Monto_Negociado','Estado']
  
  dataSource: any;

  constructor(private datepipe :DatePipe,
    private cobranzasService : CobranzasService,
    private msgTitulos : MessagesTitles,
    private msgStatus:MessagesStatus) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.DTOFiltrosJudicial.FechaInicio = this.datepipe.transform(moment().add(-30, 'day'),'yyyy-MM-dd');
    this.DTOFiltrosJudicial.FechaFin = this.datepipe.transform(moment(),'yyyy-MM-dd');
   }

  ngOnInit() {
    this.ObtenerAdquirentesCombo();
  }
  tipoMoneda(event){
    if(event==''){
      this.DTOFiltrosJudicial.Moneda = 0;
    }else{
      this.DTOFiltrosJudicial.Moneda = event;
    } 
  }
  ListadoCobranzaJudicial(){
    this.DTOFiltrosJudicial.FechaInicio = this.datepipe.transform(this.DTOFiltrosJudicial.FechaInicio,'yyyy-MM-dd')
    this.DTOFiltrosJudicial.FechaFin = this.datepipe.transform(this.DTOFiltrosJudicial.FechaFin,'yyyy-MM-dd')
   this.loading = true;

   if (this.rucAdq.value == null || this.rucAdq.value == ""){
     this.idAdqui = "";
   }

   this.cobranzasService.ObtenerDocumentosJudiciales(this.DTOFiltrosJudicial).subscribe(
     res =>{
         this.arrayJudicial = res;
         this.dataSource = new MatTableDataSource( this.arrayJudicial);
         this.dataSource.sort = this.sort;
         this.dataSource.paginator = this.paginator;
         this.loading = false;
     },err =>{
         Swal.fire({
             title: "¡Algo salió mal!",
             text:  err.error['error'],
             type: "warning",
             allowOutsideClick: true,
             heightAuto: false 
         });
         this.loading = false;
     }
   )


  }

  obtenerRucAdq(termino :string){
    this.idAdq = termino;
  }
  obtenerIdAdq(idAd :number){
    this.idAdqui = idAd;
    this.DTOFiltrosJudicial.IdAdqui = this.idAdqui;
  }

  obtenerRucRazSocialAdq(termino :string = ''){
    
    if (termino != null && termino != ''){
          
      let termino1 = termino.toLowerCase();                   
  
      for( let p of this.adquirentessArr){
  
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            
            this.idAdq = p.Num_Doc_Identificacion;

          }
      }

    }

  }

  ObtenerAdquirentesCombo() {
    
    this.adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.rucAdq.valueChanges
    .pipe(
      startWith(""),
      map(state =>
        state ? this._filterAdq(state) : this.adquirentessArr.slice()
      )
    );
    
}

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.adquirentessArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  Perdida(idCobranza_Judicial:any){
    Swal.fire({
      title: '',
      text: '¿Estás seguro de marcar como perdida '+idCobranza_Judicial+'?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, marcar como perdida',
      cancelButtonText: 'No, cancelar',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.dataEnviar.usuario = this.user.Usuario;
        this.dataEnviar.idCobranza_Judicial = idCobranza_Judicial;
        this.cobranzasService.CambiarEstadoCobranzaJudicial(this.dataEnviar)
        .subscribe(res => { 
          Swal.fire({
            title: '¡Enviado a Perdida!',
            type: 'success',
            heightAuto: false
          }).then(resp => {
            if (resp.value == true) {
              this.ListadoCobranzaJudicial();
            }
          });
    
        },(err: HttpErrorResponse)=> {
          if (err.error instanceof ErrorEvent) {
            console.error("Error Event");
        } else {
            this.msgStatus.getMessage(err.status);            
        }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "NO SE CAMBIÓ DE ESTADO. "+this.msgStatus.message ,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        })
      } else if (
        result.dismiss === Swal.DismissReason.cancel
      ) {
        this.loading = false;
      }
    })
  }

  CancelarCobranzaJudicial(element:any){
    this.abrirCancelarJudicial = true;
    this.cobranzasService.dataJudicial = element;
  }

  CerrarPopUpCanJudicial(){
    this.abrirCancelarJudicial = false;

  }
  DetalleCobranzaJudicial(element){
    this.abrirDetalleJudicial = true;
    this.cobranzasService.dataDetalleJudicial = element;
  }

  CerrarPopUpDetalleJudicial(){
    this.abrirDetalleJudicial = false;
  }

}
